/**
 * Returns environment information based on the window.hostname
 * Ex:
 * {
 *   backend: 'https://chat-api.myalex.com',
 *   frontend: 'https://chat.myalex.com',
 * }
 *
 * !!!!! NOTE: If you are changing this file, this is a reminder to revisit widget.js !!!!!
 *
 */

interface Environment {
  backend: string;
  frontend: string;
  environment: string;
}

export const getEnvironment = (): Environment => {
  const { hostname } = window.location;

  if (hostname === 'localhost' || hostname === '0.0.0.0' || hostname === '127.0.0.1') {
    return {
      backend: `https://localhost:3000`,
      frontend: `https://localhost:8080`,
      environment: 'development',
    };
  }

  if (hostname === 'frontend') {
    return {
      backend: `https://backend:3000`,
      frontend: `https://frontend:8080`,
      environment: 'development',
    };
  }

  if (hostname.match(/.makealex.com|.*(sandbox).*.jellydevs.com/)) {
    return {
      backend: 'https://chat-api-sandbox.jellydevs.com',
      frontend: 'https://chat-sandbox.jellydevs.com',
      environment: 'sandbox',
    };
  }

  if (hostname.match(/.*(qa|staging|testing).*.myalex.com|.*(staging).*.jellydevs.com/)) {
    return {
      backend: 'https://chat-api-staging.jellydevs.com',
      frontend: 'https://chat-staging.jellydevs.com',
      environment: 'staging',
    };
  }

  if (hostname.match(/.*(loadtest).*.myalex.com/)) {
    return {
      backend: 'https://chat-api-loadtest.myalex.com',
      frontend: 'https://chat-loadtest.myalex.com',
      environment: 'loadtest',
    };
  }

  if (hostname.match(/.*(demo).*.myalex.com/)) {
    return {
      backend: 'https://chat-api-demo.myalex.com',
      frontend: 'https://chat-demo.myalex.com',
      environment: 'production',
    };
  }

  // All other environment default to production
  return {
    backend: 'https://chat-api.myalex.com',
    frontend: 'https://chat.myalex.com',
    environment: 'production',
  };
};

export default { getEnvironment };
